import * as React from 'react';

interface ICommentProps {
  title:string;
  text:string;
}

export default function Comment(props:ICommentProps)  {
  return <div className='comment-wrapper'>
    <div className='comment-title'>{props.title} </div>
    <div className='comment-text'>{props.text}</div>
  </div>;
};

